module.exports = __webpack_public_path__ + "img/chevron_right.6412316e.svg";